<template>
  <div id="topresult">
    <v-progress-linear
      indeterminate
      color="primary darken-2"
      v-if="loading"
    ></v-progress-linear>

    <v-card class="tournament-card-preview" elevation="1">
      <div class="sport-live-content" style="margin: 0">
        <v-row class="pt-10 pl-3 pr-3">
          <v-col cols="12" md="12">
            <span
              @click="goBack()"
              style="cursor: pointer; text-transform: capitalize"
            >
              <v-icon dense>mdi-chevron-left</v-icon>
              {{ $t('generic.back') }}
            </span>
          </v-col>

          <v-col cols="12" md="2">
            <v-select
              v-model="form.period"
              :items="selectPeriods"
              :label="$t('period')"
              item-value="time"
              item-text="value"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-autocomplete
              v-model="form.sport"
              :items="selectSports"
              label="Sport"
              item-value="id"
              item-text="value"
              outlined
              dense
              @change="sportSelect"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="2">
            <v-autocomplete
              v-model="form.category"
              :items="selectCategories"
              :label="$t('country')"
              item-value="id"
              item-text="name"
              chips
              deletable-chips
              multiple
              small-chips
              outlined
              dense
              @change="categorySelect"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0" style="height: 25px">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  <v-chip style="height: 25px"><span>...</span></v-chip>
                </span>
              </template>
            </v-autocomplete>
            <!--          <v-autocomplete-->
            <!--                  v-model="form.category"-->
            <!--                  :items="selectCategories"-->
            <!--                  :label="$t('country')"-->
            <!--                  item-value="id"-->
            <!--                  item-text="name"-->

            <!--                  chips-->
            <!--                  deletable-chips-->
            <!--                  multiple-->
            <!--                  small-chips-->
            <!--                  outlined-->
            <!--                  dense-->
            <!--                  @change="categorySelect"-->

            <!--          ></v-autocomplete>-->
          </v-col>
          <v-col cols="12" md="2" v-if="form.category">
            <v-autocomplete
              v-model="form.tournament"
              :items="selectTournaments"
              :label="$t('tournament')"
              item-value="id"
              item-text="name"
              chips
              deletable-chips
              multiple
              small-chips
              outlined
              dense
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0" style="height: 25px">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  <v-chip style="height: 25px"><span>...</span></v-chip>
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              :label="$t('event')"
              outlined
              v-model="form.competitor"
              dense
              autocomplete="nope"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn
              block
              target="_blank"
              class="get-booked-bet-button"
              style="background: #fed430; color: #000000; font-weight: bold"
              @click="changeSport"
            >
              {{ $t('search') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="!this.getLoadingLive && getResult.length >= 1">
          <v-col cols="12">
            <div class="tournament-card-header header-live">
              <div class="">
                <span class="label-theme">{{ $t('result') }} </span>
              </div>
              <div class="">
                <a
                  style="text-decoration: none"
                  class="action-btn"
                  :href="
                    getUrlApi +
                    '/api/printresult?token=' +
                    getToken +
                    '&period=' +
                    form.period +
                    '&sheet=9&orientation=portrait&competitor=' +
                    form.competitor +
                    '&sport=' +
                    form.sport +
                    '&lang=' +
                    getLanguage +
                    '&category=' +
                    encoding(form.category) +
                    '&tournament=' +
                    encoding(form.tournament) +
                    '&timezone=' +
                    encoding(form.timezone) +
                    '&language_user=' +
                    encoding(form.language_user)
                  "
                  target="_blank"
                  >{{ $t('print') }} <v-icon dense>mdi-printer</v-icon></a
                >
              </div>
            </div>
          </v-col>
        </v-row>
        <v-progress-linear
          indeterminate
          color="primary darken-2"
          v-if="this.getLoadingLive"
        ></v-progress-linear>

        <v-col
          cols="12"
          class="tournament-card-events info-event event"
          align="center"
          justify="center"
          v-if="
            !this.getLoadingLive &&
            getResult.length == 0 &&
            getTotal == 0 &&
            getSkip == 0 &&
            !restart
          "
        >
          <div
            class="message align-center align-self-center"
            style="width: 100%"
          >
            <span class="title">{{ $t('noevent') }}</span>
            <br />
            <span class="subTitle">{{ $t('subnoevent') }}</span>
          </div>
        </v-col>
        <div
          class="preview"
          v-if="!this.getLoadingLive && getResult.length >= 1"
        >
          <v-card class="tournament-card-preview" elevation="1">
            <v-expansion-panels tile multiple class="tree">
              <v-expansion-panel v-for="(sport, i) in getResult" :key="i">
                <template>
                  <v-expansion-panel-header class="tree-sport-level">
                    <div class="path d-flex align-center">
                      <img
                        :src="categoryPath + sport.category.id + '.svg'"
                        :alt="sport.category"
                      />

                      <span class="category-text mr-2">{{ sport.cat }}</span> >
                      <span class="category-text ml-2">{{ sport.tourn }}</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="no-padding">
                    <v-expansion-panels tile class="tree-inner">
                      <v-expansion-panel
                        v-for="(event, index) in sport.events"
                        :key="event.id"
                      >
                        <div
                          :class="
                            index % 2 == 0
                              ? 'evenResult d-flex '
                              : 'oddResult d-flex '
                          "
                          @click="detailEvent(event)"
                          v-if="event.livescore"
                        >
                          <v-col
                            cols="12"
                            md="1"
                            class="no-padding info-event pt-2 pb-2 pr-2 pl-2 align-self-center"
                          >
                            {{ event.quickbet }}
                          </v-col>
                          <v-col
                            cols="12"
                            md="1"
                            class="no-padding info-event pt-2 pb-2 pr-2 pl-2 align-self-center"
                          >
                            {{
                              new Date(event.scheduled).toLocaleDateString(
                                'en-GB',
                                { month: 'numeric', day: 'numeric' }
                              )
                            }}
                            {{
                              new Date(event.scheduled).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit',
                              })
                            }}
                            <!--<span v-if="getUserType == 4 || getCashier || !getSettings.enableQuickBetOnlyForAgency"  class="event-qbet" title="qbet">
                                  {{ event.events[0].quickbet }}
                                </span>-->
                          </v-col>

                          <v-col
                            cols="12"
                            md="8"
                            class="no-padding info-event pt-2 pb-2 pr-2 pl-2 align-self-center"
                          >
                            <!--<span v-if="getUserType == 4 || getCashier || !getSettings.enableQuickBetOnlyForAgency"  class="event-qbet" title="qbet">
                              {{ event.events[0].quickbet }}
                            </span>-->

                            <span class="home">{{ event.home }}</span> -
                            <span class="away">{{ event.away }}</span>
                          </v-col>
                          <v-col
                            cols="12"
                            md="2"
                            class="no-padding info-event pt-2 pb-2 pr-2 pl-2 text-right align-self-center"
                          >
                            <div class="info-match-result">
                              <span
                                class="result"
                                v-if="
                                  event.livescore && event.livescore.Scoreboard
                                "
                              >
                                {{
                                  event.livescore.Scoreboard.Results[0].Value
                                }}
                                :
                                {{
                                  event.livescore.Scoreboard.Results[1].Value
                                }}
                              </span>
                            </div>
                          </v-col>
                        </div>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-expansion-panel-content>
                </template>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </div>
      </div>
      <v-progress-linear
        indeterminate
        color="primary darken-2"
        v-if="this.loadingmore"
      ></v-progress-linear>
      <div v-if="getResult.length > 0 && getTotal == 15 && !restart">
        <div class="text-center pb-2" @click="getDataEventsDayMore">
          <span class="action-btn show-others" :title="$t('loadmore')"
            >{{ $t('loadmore') }} <v-icon dense>mdi-chevron-right</v-icon></span
          >
        </div>
      </div>
    </v-card>

    <v-dialog
      v-model="dialog"
      width="40%"
      content-class="modal-on-top"
      :overlay-opacity="0.9"
      v-if="this.dialog && !getModalIdle"
    >
      <v-card>
        <v-overlay :value="overlay_dialog_betlist_detail">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row
          class="event-card-intro no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundPath +
            object.sport.id +
            '.webp\');height: 90px;background-size: cover;'
          "
        >
          <v-col cols="12" md="5" class="no-padding align-middle flex-end">
            <div class="competitor" style="display: flex; align-items: center">
              <div class="flag" :title="object.home">
                <img
                  :src="flagTeamsPath + object.competitors[0].id + '.png'"
                  :alt="object.home"
                />
              </div>
              <div class="name">{{ object.home }}</div>
              <span
                class="result"
                v-if="object.livescore && object.livescore.Scoreboard"
                style="font-size: 40px; padding-left: 20px; padding-right: 20px"
              >
                {{ object.livescore.Scoreboard.Results[0].Value }}
              </span>
            </div>
          </v-col>

          <v-col cols="12" md="2" class="no-padding align-middle flex-center">
            <div class="match-date text-center">
              <span class="time">
                {{
                  new Date(object.scheduled).toLocaleDateString('en-GB', {
                    month: 'numeric',
                    day: 'numeric',
                  })
                }}
                {{
                  new Date(object.scheduled).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                  })
                }}
              </span>
              <!--<span class="day">{{ object.event.day }}</span>-->
              <br />
              <span class="event-qbet" title="qbet">
                {{ object.quickbet }}
              </span>
            </div>
          </v-col>

          <v-col cols="12" md="5" class="no-padding align-middle flex-start">
            <div
              class="competitor away"
              style="display: flex; align-items: center"
            >
              <span
                class="result"
                v-if="object.livescore && object.livescore.Scoreboard"
                style="font-size: 40px; padding-left: 20px; padding-right: 30px"
              >
                {{ object.livescore.Scoreboard.Results[1].Value }}
              </span>
              <div class="name">{{ object.away }}</div>
              <div class="flag" :title="object.away">
                <img
                  :src="flagTeamsPath + object.competitors[1].id + '.png'"
                  :alt="object.away"
                />
              </div>
            </div>
          </v-col>
        </v-row>
        <v-card-text>
          <v-container class="mt-4 mb-6 no-padding">
            <v-row style="color: #ffffff">
              <v-col
                cols="12"
                md="6"
                class="no-padding no-margin pt-2 pb-2 pr-2 pl-2"
              >
                <div>{{ $t('statistics.matchsummary') }}</div>

                <div
                  v-if="object.livescore.Periods"
                  v-for="(period, index) in object.livescore.Periods"
                  :key="index"
                  style="border-bottom: 1px solid #000000"
                >
                  <v-row
                    class="no-padding no-margin align-self-center"
                    style="background-color: #272727; font-size: 12px"
                  >
                    <v-col cols="12" sm="6" class="pt-1 pb-1 pr-2 pl-2">
                      {{ period.Type[0].text }}
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      class="pt-1 pb-1 pr-2 pl-2 text-right"
                    >
                      {{ period.Results[0].Value }} :
                      {{ period.Results[1].Value }}
                    </v-col>
                  </v-row>

                  <v-row
                    :class="
                      index % 2 == 0
                        ? 'evenResult d-flex no-padding no-margin '
                        : 'oddResult dd-flex no-padding no-margin '
                    "
                    v-for="(player, index) in period.Incidents"
                    :key="index"
                    style="font-size: 12px"
                  >
                    <v-col cols="12" sm="6" class="pt-1 pb-1 pr-2 pl-2">
                      <span v-if="player.ParticipantPosition == '1'">
                        <span v-if="player.PlayerName != 'Unknown'">{{
                          player.PlayerName
                        }}</span>
                        <span v-if="player.Seconds">
                          ({{ (player.Seconds / 60).toFixed(0) }}°)
                        </span>
                      </span>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      class="pt-1 pb-1 pr-2 pl-2 text-right"
                    >
                      <span v-if="player.ParticipantPosition == '2'">
                        <span v-if="player.Seconds">
                          ({{ (player.Seconds / 60).toFixed(0) }}°)
                        </span>
                        <span v-if="player.PlayerName != 'Unknown'">{{
                          player.PlayerName
                        }}</span>
                      </span>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="no-padding no-margin pt-2 pb-2 pr-2 pl-2"
              >
                <div>{{ $t('statistics.statistics') }}</div>
                <v-row
                  class="no-padding no-margin align-self-center"
                  style="background-color: #272727; font-size: 12px"
                >
                  <v-col cols="12" sm="6" class="pt-1 pb-1 pr-2 pl-2">
                    {{ object.home }}
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    class="pt-1 pb-1 pr-2 pl-2 text-right"
                  >
                    {{ object.away }}
                  </v-col>
                </v-row>
                <div
                  v-for="(stat, index) in object.livescore.Statistics"
                  :key="index"
                >
                  <v-row
                    :class="
                      index % 2 == 0
                        ? 'evenResult d-flex no-padding no-margin '
                        : 'oddResult dd-flex no-padding no-margin '
                    "
                    style="font-size: 12px"
                  >
                    <v-col cols="12" sm="2" class="pt-1 pb-1 pr-2 pl-2">
                      <!--<span v-if="player.ParticipantPosition=='1'">
                          {{ player.PlayerName }}
                      </span>-->
                      {{ stat.Results[0].Value }}
                    </v-col>
                    <v-col
                      cols="12"
                      sm="8"
                      class="pt-1 pb-1 pr-2 pl-2 text-center"
                    >
                      <!--<span v-if="player.ParticipantPosition=='1'">
                          {{ player.PlayerName }}
                      </span>-->
                      {{ result(stat.Type) }}
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      class="pt-1 pb-1 pr-2 pl-2 text-right"
                    >
                      <!--<span v-if="player.ParticipantPosition=='2'">
                          {{ player.PlayerName}}
                      </span>-->
                      {{ stat.Results[1].Value }}
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="stat.Incidents"
                    v-for="inc in stat.Incidents"
                    :key="index"
                    :class="
                      index % 2 == 0
                        ? 'evenResult d-flex no-padding no-margin '
                        : 'oddResult dd-flex no-padding no-margin '
                    "
                    style="font-size: 12px"
                  >
                    <v-col cols="12" sm="6" class="pt-1 pb-1 pr-2 pl-2">
                      <span v-if="inc.ParticipantPosition == '1'">
                        <span v-if="inc.PlayerName != 'Unknown'">{{
                          inc.PlayerName
                        }}</span>
                        <span v-if="inc.Seconds">
                          ({{ (inc.Seconds / 60).toFixed(0) }}°)
                        </span>
                      </span>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      class="pt-1 pb-1 pr-2 pl-2 text-right"
                    >
                      <span v-if="inc.ParticipantPosition == '2'">
                        <span v-if="inc.Seconds">
                          ({{ (inc.Seconds / 60).toFixed(0) }}°)
                        </span>
                        <span v-if="inc.PlayerName != 'Unknown'">{{
                          inc.PlayerName
                        }}</span>
                      </span>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" text @click="dialog = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from 'lodash'

import { isMobileOnly } from 'mobile-device-detect'
import { isTablet } from 'mobile-device-detect'
import { uuid } from 'vue-uuid'

import forEach from 'lodash/forEach'
import findLodash from 'lodash/find'
import size from 'lodash/size'
import filter from 'lodash/filter'
import orderByLodash from 'lodash/orderBy'

export default {
  name: 'Results',
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    sportIdsPlayerServer: [3467550448],
    limit: 30,
    livesCount: [],
    loading: false,
    loadingmore: false,
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT +
      '/svg/categories/rectangular_flags_category/',
    sportBackgroundPath:
      'https://rocky-revenge.s3-eu-west-1.amazonaws.com/svg/sports-bg/',
    flagTeamsPath: process.env.VUE_APP_URL_FLAG_TEAMS_CLOUDFRONT + '/medium/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/light/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons/',
    light: window.icons == 'light' ? true : false,
    markets: [],
    market_selected: '',
    markets_size: 0,
    markets_size2: 0,
    all_categories: [],
    categories_filtered: [],
    overlay_dialog_betlist_detail: false,
    form: {
      period: 24,
      sport: 8412615417,
      tournament: [],
      category: [],
      competitor: '',
      language_user: '',
      timezone: '',
      skip: 0,
      limit: 10,
    },
    selectPeriods: [],
    selectSports: [],
    selectCategories: [],
    selectTournaments: [],
    fecthResults: [],
    restart: false,
    dialog: false,
    object: {},
  }),
  components: {},
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getPlatform: 'settings/getPlatformSettings',
      getFilter: 'tree/getFilter',
      getPreviewLive: 'odds/getPreviewLive',
      getCountLive: 'odds/getCountLive',
      getEventsLiveDetailActive: 'odds/getEventsLiveDetailActive',
      getLoadingPreview: 'odds/getLoadingPreview',
      getLoadingLive: 'odds/getLoadingLive',
      getOddsSources: 'cart/getOddsSources',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getPlatformId: 'settings/getPlatformId',
      getEventsLiveDetail: 'odds/getEventsLiveDetail',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
      getSports: 'sport/getSports',
      getTree: 'tree/getTree',
      getTournamentsActive: 'odds/getTournamentsActive',

      getResult: 'result/getItems',
      getSkip: 'result/getSkip',
      getLimit: 'result/getLimit',
      getTotal: 'result/getTotal',
      getUrlApi: 'settings/getUrlApi',
      getToken: 'user/getToken',
      getModalIdle: 'user/getModalIdle',
    }),
  },
  methods: {
    ...mapActions({
      setFilter: 'tree/setFilter',
      removeFromPreview: 'odds/removeFromPreview',
      fetchEventDetail: 'odds/fetchEventDetail',
      fetchEventLiveDetail: 'odds/fetchEventLiveDetail',
      setLoadingPreview: 'odds/setLoadingPreview',
      setLoadingLive: 'odds/setLoadingLive',
      //'addOddToCart': 'cart/addOddToCart',
      fetchLive: 'odds/fetchLive',
      setLiveMode: 'odds/setLiveMode',
      setLiveSportSelected: 'odds/setLiveSportSelected',

      fetchCategorySport: 'tree/fetchCategorySport',
      fetchTournamentByCategory: 'tree/fetchTournamentByCategory',
      fetchResuls: 'result/fetchResult',
      setSkip: 'result/setSkip',
      emptyResult: 'result/emptyResult',
    }),

    encoding(url) {
      //console.log(url)
      return encodeURIComponent(url)
    },
    result(type) {
      let response = type
      switch (type) {
        case 1:
          response = this.$t('statistics.corner')
          break
        case 6:
          response = this.$t('statistics.yellow')
          break
        case 7:
          response = this.$t('statistics.red')
          break
        case 8:
          response = this.$t('statistics.penalties')
          break
        case 9:
          response = this.$t('statistics.goal')
          break
        case 10:
          response = this.$t('statistics.substitutions')
          break
        case 24:
          response = this.$t('statistics.owngoal')
          break
        case 25:
          response = this.$t('statistics.penaltygoal')
          break
        case 40:
          response = this.$t('statistics.missedpenalty')
          break
        case 20:
          response = this.$t('statistics.aces')
          break
        case 21:
          response = this.$t('statistics.doublefaults')
          break
        case 34:
          response = this.$t('statistics.firstservewins')
          break
        case 12:
          response = this.$t('statistics.fouls')
          break
        case 28:
          response = this.$t('statistics.twopoints')
          break
        case 30:
          response = this.$t('statistics.threepoints')
          break
        case 31:
          response = this.$t('statistics.timeouts')
          break
        case 32:
          response = this.$t('statistics.freethrows')
          break
        case 33:
          response = this.$t('statistics.hits')
          break
      }
      return response
    },
    async orderData(data) {
      if (data.length > 0) {
        const array = await orderByLodash(data, ['source'], ['ASC'])
        //console.log("array",array)
        return array
      } else {
        return []
      }
    },
    async getDataEventsDayMore() {
      await this.setSkip({ skip: this.getSkip + this.getLimit })
      //console.log("this.getDaySkip",this.getDaySkip)
      //return
      this.loadingmore = true
      //await this.fetchEventsDayMore({sport: this.sport_active, language_user: this.getUserLanguage, timezone: this.getUserTimezone,skip:this.getDaySkip,limit:this.getDayLimit});
      this.form.language_user = this.getLanguage
      this.form.timezone = this.getPlatform.timezone
      this.form.skip = this.getSkip
      this.form.limit = this.getLimit
      await this.fetchResuls(this.form)
      this.loadingmore = false
    },
    async changeSport() {
      this.restart = true
      //console.log("FORM",this.form)
      this.loadingmore = true
      await this.emptyResult()
      //await this.fetchEventsDayMore({sport: this.sport_active, language_user: this.getUserLanguage, timezone: this.getUserTimezone,skip:this.getDaySkip,limit:this.getDayLimit});
      this.form.language_user = this.getLanguage
      this.form.timezone = this.getPlatform.timezone
      this.form.skip = this.getSkip
      this.form.limit = this.getLimit
      await this.fetchResuls(this.form)
      this.restart = false
      this.loadingmore = false
    },
    async convertCategory(priority) {
      return priority
      //console.log("A",convertCategory)
      if (size(this.getResult) > 0) {
        var response = await findLodash(priority.detail, {
          lang: this.getLanguage,
        })
      }
      //console.log("B",response.text)

      return response.text
    },
    async sportSelect(sport) {
      // await this.setLoadingLive({status: true})
      const listCategories = await this.fetchCategorySport({ sport: sport })
      this.form.category = []
      this.form.tournament = []
      this.selectCategories = []
      if (size(listCategories) > 0) {
        forEach(listCategories, list => {
          if (list.active) {
            const nameCat = findLodash(list.detail, {
              lang: this.getLanguage,
            }).text
            this.selectCategories.push({ id: list.id, name: nameCat })
          }
        })
      }
      this.selectCategories = orderByLodash(
        this.selectCategories,
        ['name'],
        ['asc']
      )
      //await this.setLoadingLive({status: false})
    },
    async detailEvent(event) {
      //this.loading = true
      event.livescore.Periods = await orderByLodash(
        event.livescore.Periods,
        ['source'],
        ['ASC']
      )
      forEach(event.livescore.Periods, period => {
        //{{findLodash(period.Type,{lang:getLanguage}).text}}
        period.Type = filter(period.Type, { lang: this.getLanguage })
      })
      //{{findLodash(period.Type,{lang:getLanguage}).text}}
      // console.log(event)
      this.object = event
      this.dialog = true
      const sleep = m => new Promise(r => setTimeout(r, m))
      await sleep(100)
      document.body.scrollIntoView({ behavior: 'smooth', block: 'start' })

      /* const sleep = m => new Promise(r => setTimeout(r, m))

      await sleep(100)
      this.dialog=true
      this.loading = false*/

      //this.$refs.top.scrollIntoView()
      //this.scrollIntoView({behavior: 'smooth'});
      // const container = this.$el.querySelector("#container");
      //const container = this.$el.querySelector("container");
      //console.log(container)
      //window.scrollIntoView({ behavior: 'smooth' })
      //var el = document.getElementById("topresult")
      /*.scrollIntoView({
        behavior: "smooth"
      });*/
      //el.scrollTop = el.innerHeight;

      //console.log(container.scrollHeight)
      //container.scrollTop = 0;
      //this.dialog=true
      //console.log(event)
    },
    async categorySelect() {
      //await this.setLoadingLive({status: true})

      this.form.tournament = []
      const listTournaments = await this.fetchTournamentByCategory({
        categories: JSON.stringify(this.form.category),
      })
      this.selectTournaments = []
      if (size(listTournaments) > 0) {
        forEach(listTournaments, list => {
          if (list.active) {
            const nameCat = findLodash(list.detail, {
              lang: this.getLanguage,
            }).text
            this.selectTournaments.push({ id: list.id, name: nameCat })
          }
        })
      }
      //await this.setLoadingLive({status: false})
      //categoryTournament
    },

    /*async changeLive(sport) {
      await this.setLoadingLive({status: true})
      await this.setLiveSportSelected({data:{}})
      await this.fetchLive({sport: sport.id, sport_id: sport._id, group: true});
      this.getMarkets()
      this.getCategories()
      await this.setLoadingLive({status: false})
    },*/

    /* getResult(result, team) {
      if (team == 'home') {
        var point = findLodash(result, {'Position': "1"})
        return (point) ? +point.Value : 0
      } else if (team == 'away') {
        var point = findLodash(result, {'Position': "2"})
        return (point) ? +point.Value : 0
      } else {
        return 0
      }
    },*/
    goBack() {
      this.setLiveMode({ mode: 'preview' })
    },
  },

  async mounted() {
    await this.setLoadingLive({ status: true })
    this.selectPeriods = [
      { time: 24, value: this.$t('24h') },
      { time: 48, value: this.$t('48h') },
      { time: 96, value: this.$t('4d') },
      { time: 168, value: this.$t('7d') },
    ]

    forEach(this.getSports, sport => {
      const title = findLodash(sport.detail, { lang: this.getLanguage }).text
      this.selectSports.push({ value: title, id: sport.id, order: sport.order })
    })

    this.selectSports = orderByLodash(this.selectSports, ['order'], ['asc'])

    const listCategories = await this.fetchCategorySport({ sport: 8412615417 })
    this.selectCategories = []
    if (size(listCategories) > 0) {
      forEach(listCategories, list => {
        if (list.active) {
          const nameCat = findLodash(list.detail, {
            lang: this.getLanguage,
          }).text
          this.selectCategories.push({ id: list.id, name: nameCat })
        }
      })
    }
    this.selectCategories = orderByLodash(
      this.selectCategories,
      ['name'],
      ['asc']
    )
    this.form.language_user = this.getLanguage
    this.form.timezone = this.getPlatform.timezone
    this.form.skip = this.getSkip
    this.form.limit = this.getLimit
    this.fecthResults = await this.fetchResuls(this.form)

    await this.setLoadingLive({ status: false })

    /*this.$root.$on('forceUpdateLivePreview', () => {
      this.initMarkets()
    })
    await this.initMarkets()*/
  },

  async created() {},
}
</script>
<style>
.img-sport-light {
  filter: invert(1);
}

.img-sport-dark {
  filter: invert(0);
}

.filter-live-category {
  display: flex;
  padding-bottom: 5px !important;
  padding-top: 5px !important;
}

.img-flag-filter {
  width: 20px;
  margin-right: 5px !important;
}

.sport-live-content .count {
  background: red;
  padding: 2px 4px;
  border-radius: 3px;
  position: absolute;
  right: -20px;
  top: -8px;
  font-size: 10px;
  color: #fff !important;
}

.filter-live-category i {
  color: var(--active-color) !important;
}
</style>
